<template>
    <div class="root">
        <header>Information Collection and Use of Third-Party SDKs</header>
        <p>
            <b>
                To ensure the implementation of related functions of Haba and the safe and stable operation of the
                app, we may access SDKs provided by third parties to implement related functions.
            </b>
        </p>
        <p>
            <b>
                The third-party SDKs we access serve the needs of you and other users, so we may adjust the third-party
                SDKs we access to meet new service requirements and changes in service functions. Of course,we will keep
                you updated on access to third-party SDKs in this description.
            </b>
        </p>
        <p>
            <b>
                1.Log In
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>Facebook</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Meta</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Log in and complete user profile</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>OpenID, username,profile photo</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.facebook.com/privacy/explanation/">https://www.facebook.com/privacy/explanation/</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Twitter</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Twitter</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Log in and complete user profile</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>OpenID, username,profile photo</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://twitter.com/en/privacy">https://twitter.com/en/privacy</a></td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Apple</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Apple</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Log in and complete user profile</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>OpenID, username</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.apple.com/legal/privacy/en-ww/">https://www.apple.com/legal/privacy/en-ww/</a>
                </td>
            </tr>
        </table>
        <p>
            <b>
                2. SMS and Messages
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>Vonage</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Vonage</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>SMS verification code</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.vonage.com/legal/privacy-policy/?bypassgeoloc=true">https://www.vonage.com/legal/privacy-policy/?bypassgeoloc=true</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Infobip</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Infobip</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>SMS verification code</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.infobip.com/policies/privacy">https://www.infobip.com/policies/privacy</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Nxtele</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Nxtele</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>SMS verification code</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.nxcloud.com/register">https://www.nxcloud.com/register</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>CM</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>CM.com</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>SMS verification code</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.cm.com/app/legal/cm-com/privacy-policy/">https://www.cm.com/app/legal/cm-com/privacy-policy/</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Yunpian</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Yunpian</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>SMS verification code</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.yunpian.com/official/document/sm
                    s/zh_CN/agreement_privacyagreement?lang=en">https://www.yunpian.com/official/document/sm
                        s/zh_CN/agreement_privacyagreement?lang=en</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>MessageBird</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>MessageBird</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>WhatsApp messages</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://messagebird.com/en/legal/privacy">https://messagebird.com/en/legal/privacy</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>Firebase</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Google</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Android push</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Device info</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://firebase.google.com/terms/?https%3A%2F%2Ffirebase.google.com%2Fsupport%2Fprivacy%3Fhl">https://firebase.google.com/terms/?https%3A%2F%2Ffirebase.google.com%2Fsupport%2Fprivacy%3Fhl</a>
                </td>
            </tr>
        </table>

        <table>
            <tr>
                <th>SDK</th>
                <th>Tencent Cloud</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Tencent</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Instant Messaging</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Log Data，Monitoring Data，Configuration Data</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.tencentcloud.com/document/product/1047/45407">https://www.tencentcloud.com/document/product/1047/45407</a>
                </td>
            </tr>
        </table>

        <p>
            <b>
                3. Storage
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>Qiniu</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Qiniu Cloud</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Image storage and audio file storage</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Images and audio files</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.qiniu.com/agreements/privacy-right/en">https://www.qiniu.com/agreements/privacy-right/en</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>AWS</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Amazon</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>File storage and image recognition</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Images and audio files</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://aws.amazon.com/privacy/?nc1=f_pr">https://aws.amazon.com/privacy/?nc1=f_pr</a>
                </td>
            </tr>
        </table>
        <p>
            <b>
                4. Audio
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>Agora</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Agora</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Voice calls</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Network type, user local IP address, WIFI and cellular network signal status, operating system,
                    device model, CPU, memory, device power, audio stream data, Bluetooth, network delay, packet loss
                    rate, bit rate, resolution, audio bit rate, sample rate, sample rate</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.agora.io/cn/privacy-policy">https://www.agora.io/cn/privacy-policy</a>
                </td>
            </tr>
        </table>
        <p>
            <b>
                5. Security
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>Ali Cloud</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Alibaba</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Image recognition and SMS</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Images and mobile number</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-
                    international-website-privacy-policy">https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-
                        international-website-privacy-policy</a>
                </td>
            </tr>
        </table>
        <p>
            <b>
                6. Other
            </b>
        </p>
        <table>
            <tr>
                <th>SDK</th>
                <th>AppsFlyer</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Alibaba</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Installation data attribution analysis</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>
                    <ur>
                        <li>
                            "Personal Information" such as name, email, contact details or any other personal content
                            that you provide to us
                            whether through a form or field on our website or any other communication (e.g. email,
                            phone, post etc.).
                        </li>
                    </ur>
                    <ur>
                        <li>
                            "Technical Information" such as browser type, operating
                            system, device type, IP address and other similar technical information typically received
                            from a browser or device automatically when visiting or interacting with our
                            Marketing Platforms.This may include the referring URL that led you to our website.

                        </li>
                    </ur>
                    <ur>
                        <li>
                            "Usage Information" such as the pages you visited on our website, where you clicked,
                            searches performed on our website and other similar information related to how you have used
                            our website. It may also include information related to whether you received, opened on
                            clicked on any links in an email sent to you.
                        </li>
                    </ur>
                </td>

            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a
                        href="https://www.appsflyer.com/website-privacy-policy/">https://www.appsflyer.com/website-privacy-policy/</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>GeeTest</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>GeeTest</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Behavior verification</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>
                    <ur>
                        <li>
                            Device information: operating system, manufacturer, device model, device brand, and other
                            information; this information is desensitized and used to establish an abnormal traffic
                            identification model to implement traffic anti-fraud technology.
                        </li>
                    </ur>
                    <ur>
                        <li>
                            Device network information: information such as device
                            networking status and type; this information is desensitized and used to establish abnormal
                            and virtual device identification models to implement traffic anti-fraud technology.

                        </li>
                    </ur>
                    <ur>
                        <li>
                            Device environment information: device screen size,battery charging status, device power,
                            device jailbreak logo, device debugging logo, and other information; this
                            information is desensitized and used to establish abnormal and virtual device identification
                            models to implement traffic anti-fraud technology.
                        </li>
                    </ur>
                    <ur>
                        <li>
                            User biometric track information: This kind of information does not refer to the business
                            jump track information generated by the user jumping from one page to another page, but
                            refers to the track of the user's sliding, clicking, mouse movement, etc. generated during
                            the operation verification process. Information; this information is desensitized and used
                            to establish simulation, violence, and forged trajectory recognition models to realize
                            traffic anti-fraud technology.
                        </li>
                    </ur>
                    <ur>
                        <li>
                            Other information: verification time stamp, installation package name, and other
                            information; this information is used to establish a basic anomaly-assisted identification
                            model and implement traffic anti-fraud technology.
                        </li>
                    </ur>
                </td>

            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.geetest.com/en/Privacy">https://www.geetest.com/en/Privacy</a>
                </td>
            </tr>
        </table>
        <br>
        <table>
            <tr>
                <th>SDK</th>
                <th>umeng</th>
            </tr>
            <tr>
                <td>Manufacturer</td>
                <td>Umeng Statistical Analysis SDK</td>
            </tr>
            <tr>
                <td>
                    Purpose of Use
                </td>
                <td>Conduct APP operation statistics and analysis</td>
            </tr>
            <tr>
                <td>Collected Information</td>
                <td>Device information (IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM card, IMSI/ICCID), location
                    information, network information</td>
            </tr>
            <tr>
                <td>Privacy Policy</td>
                <td><a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
                </td>
            </tr>
        </table>


    </div>
</template>  

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
